// @flow

import type { AppType } from "shared/types/AppType"

export default ({
  asyncComponentResolve: () =>
    import("apps/traffic-management/TrafficManagementEntry"),
  iconType: "form",
  name: "traffic-management"
}: AppType)
